import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "../../tools/AppConfig";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import Waiting from '../waiting';
import './../../custom.css';
import './../../pages/invoice.css';
import valu_logoImg from './../../../statics/img/payment_methods_logos/ValU.png';
import acceptBlueImg from './../../../statics/img/accept_blue.png';
import validator from 'validator';
import 'icheck/skins/all.css'; // or single skin css
import {Radio, RadioGroup} from 'react-icheck';
import './valu.css';

let max_down_payment = 0;
let total_amount = 0;

const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
  }
};
const MaxDownPayment = (value) => {
    let current_value = 0;
    if(document.getElementById("down_payment_input_id")){
        current_value = Number(document.getElementById("down_payment_input_id").value);
    }
    if(!validator.isNumeric(value) || current_value < 0 || current_value >  max_down_payment){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Down Payment from 0 to {max_down_payment}.</div>;
    }
};
const PhoneNumber = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length > 11 || value.toString().trim().length < 11 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Phone number.</div>;
    }
};
const PremiumCard = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 16 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Premium Card number.</div>;
    }
};
const Pin = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 6 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Premium Card number.</div>;
    }
};

class valu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            waitingHeight: '221px',
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            phoneNumber: '',
            productAmount: props.userData.amount,
            downPayment: 0,
            gift_card_amount: '',
            cashback_amount: '',
            quantity: this.props.quantity,
            plans: [],
            currentPlan: '',
            pmk: '',
            reference: '',
            pin: '',
            hideFirstStep: false,
            firstFormSubmitBtn: true,
            secondSetpShow: false,
            //check tenures
            tenure_waiting: true,
            check_tenure_path: "/api/acceptance/valu_checkout/valu_tenure_inquiry",
            last_phoneNumber: "",
            last_downPayment: 0,
            last_gift_card_amount: '',
            last_cashback_amount: '',
            check_tenure_error: false,
            check_tenure_error_message: ""

        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
        this.handleDownPaymentChange = this.handleDownPaymentChange.bind(this);
        this.handlePlanChange = this.handlePlanChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handelPinChange = this.handelPinChange.bind(this);
        this.handleForm2Submit = this.handleForm2Submit.bind(this);
        
    }
    componentDidMount(){
        if(this.props.sourcePage == "invoice"){
            total_amount = Number(this.state.userData.order_amount_egp);
        }else{
            total_amount = Number(this.state.userData.amount);
        }
        max_down_payment = total_amount/100 * 80;
    }
    check_new_tenures = () => {
        if(
            this.state.phoneNumber.length == 11 && 
            (
                this.state.phoneNumber != this.state.last_phoneNumber || 
                this.state.downPayment != this.state.last_downPayment || 
                this.state.gift_card_amount != this.state.last_gift_card_amount || 
                this.state.cashback_amount != this.state.last_cashback_amount
            )
        ){
            this.get_new_tenures();
        }
    }
    get_new_tenures = () => {
        this.setState({tenure_waiting: true }, () =>{
            let url = appConfig.getServerUrl() + '' + this.state.check_tenure_path;
            let data = {
                "payment_token": this.state.userData.valu_payment_key,
                "mobile_number": this.state.phoneNumber,
                "down_payment": Number(this.state.downPayment)
            }
            if(this.state.gift_card_amount){data["gift_card_amount"] = this.state.gift_card_amount}
            if(this.state.cashback_amount){data["cashback_amount"] = this.state.cashback_amount}
            let dataDict = JSON.stringify(data);
            let config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };
            axios.post(url, dataDict, config)
            .then((resp) => {
                this.setState({
                    tenure_waiting: false,
                    plans: [...resp.data.tenure_list],
                    check_tenure_error: false,
                    check_tenure_error_message: "",
                    currentPlan: "",
                    
                    last_phoneNumber: this.state.phoneNumber,
                    last_downPayment: this.state.downPayment,
                    last_gift_card_amount: this.state.gift_card_amount,
                    last_cashback_amount: this.state.cashback_amount
                })
            })
            .catch((err) => {
                this.setState({
                    tenure_waiting: false,
                    check_tenure_error: true,
                    check_tenure_error_message: "Something went wrong, Please try again later. If this problem persists, please contact your service provider."
                })
            });
        })
    }
    getFirstName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[0]
    }
    getLastName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[namesArr.length - 1];
    }
    handlePhoneNumberChange(e) {
        this.setState({phoneNumber: e.target.value},()=>{
            this.check_new_tenures();
        });
    }
    handleDownPaymentChange(e){
        let amount = e.target.value;
        if(e.target.value == ""){
            amount = "0";
        }
        this.setState({downPayment: amount}, () => {
            this.check_new_tenures();
        });
    }
    handleGiftCardChange = (e) => {
        this.setState({gift_card_amount: e.target.value}, () => {
            this.check_new_tenures();
        });
    }
    handleCashbackChange = (e) => {
        this.setState({cashback_amount: e.target.value}, () => {
            this.check_new_tenures();
        });
    }
    handlePlanChange(e){
        this.setState({currentPlan: e.target.value});
    }
    handleSubmit(event) {
        //--- strat waiting
        this.setState({waiting: true});
        //disable payment methods
        this.props.disableAllPaymentMethods();
        //---- send request 
        let url;
        if(this.props.sourcePage ==='invoice'){
            url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
        }else if(this.props.sourcePage ==='product'){
            url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
        }
        let paymentDict;
        if(this.props.sourcePage ==='invoice'){
            paymentDict = {
                "source": {
                    "identifier": this.state.phoneNumber,
                    "down_payment": this.state.downPayment,
                    "tenure": this.state.currentPlan,
                    "subtype": "VALU"
                }, 
                "shipping_data": {
                    'apartment': "",
                    'email': this.state.userData.order_email,
                    'floor': "",
                    'first_name': this.getFirstName(this.state.userData.order_full_name),
                    'street': "",
                    'building': "",
                    'phone_number': this.state.userData.order_phone,
                    'postal_code': "",
                    'city': "",
                    'country': "",
                    'last_name': this.getLastName(this.state.userData.order_full_name),
                    'state': "",
                    'extra_description': ""
                },
                "token": this.state.userData.token,
                "integration_id": this.state.userData.integration_ids.VALU        
            };
            if(this.state.deliveryNeed){
                paymentDict.shipping_data.country = this.state.deliveryData.country;
                paymentDict.shipping_data.state = this.state.deliveryData.state;
                paymentDict.shipping_data.city = this.state.deliveryData.city;
                paymentDict.shipping_data.building = this.state.deliveryData.building;
                paymentDict.shipping_data.street = this.state.deliveryData.street;
                paymentDict.shipping_data.floor = this.state.deliveryData.floor;
                paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
                paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
                paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
            }
        }else if(this.props.sourcePage ==='product'){
            paymentDict = {
                "order_data": {
                    "delivery_needed": this.state.deliveryNeed,
                    "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                    "currency": this.state.userData.currency,
                    "shipping_data": {
                        "first_name": this.getFirstName(this.state.deliveryData.name),
                        "last_name": this.getLastName(this.state.deliveryData.name),
                        "phone_number": this.state.deliveryData.phone,
                        "email": this.state.deliveryData.email,
                        "street": 'NA',
                        "city": 'NA',
                        "country": 'NA',
                        "postal_code": 'NA',
                        "state": "NA"
                    },
                    "items": [{
                        "name": this.state.userData.product.product_name,
                        "amount_cents": this.state.userData.amount * 100,
                        "quantity": this.props.quantity,
                    }]
                },
                "source": {
                    "identifier": this.state.phoneNumber,
                    "down_payment": this.state.downPayment,
                    "tenure": this.state.currentPlan,
                    "subtype": "VALU"
                },
                "token": this.state.userData.token,
                "integration_id": this.state.userData.integrations.VALU
            };
            if(this.state.deliveryNeed){
                paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
                paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
                paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
                paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
                paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
                paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
                paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
                paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
                paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
            }
        }
        paymentDict = JSON.stringify(paymentDict);
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.post(url, paymentDict, config)
        .then((resp) => {        
            if(resp.data.success){
                //set pmk value & reference value and & waiting & show second form % disable first form & remove first form submit button
                this.setState({pmk: resp.data.pmk, reference: resp.data.reference, waiting: false, secondSetpShow: true, hideFirstStep: true, firstFormSubmitBtn: false});
                //enable payment methods
                this.props.enableAllPaymentMethods();
            } else {
                if (resp.data.url) {
                    window.location.replace(resp.data.url);
                    //window.location.href = resp.data.redirection_url;
                }
                if (resp.data.data.message) {
                    this.props.setReqComplete({head: 'Transaction declined', body: resp.data.data.message });
                } else {
                    this.props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
                }
            }
        })
        .catch((err) => {
            this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
        });
        event.preventDefault();
    }
    handelPinChange(e){
        this.setState({pin: e.target.value});
    }
    handleForm2Submit(event){
        //--- strat waiting
        this.setState({waitingHeight: '289px', waiting: true});
        //disable payment methods
        this.props.disableAllPaymentMethods();
        //send request
        let url= appConfig.getServerUrl() + '/api/acceptance/valu_checkout';
        let opt_dict = {
            "payment_token": this.state.pmk,
            "reference": this.state.reference,
            "otp": this.state.pin
        };
        let paymentDict = JSON.stringify(opt_dict);
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.post(url, paymentDict, config)
        .then((resp) => {
            if(resp.data.success == true || resp.data.success === "true"){
                // if(resp.data.redirection_url){
                //     window.location.replace(resp.data.redirection_url);
                //     //window.location.href = resp.data.redirection_url;
                // }else 
                if(resp.data.data.message){
                    this.props.setReqComplete({head: 'Payment Successful', body: resp.data.data.message});
                }else{
                    this.props.setReqComplete({head: 'Payment Successful', body:'Congratulations, your transaction completed successfully.'});
                }
            }else{
                //succes = false
                if(resp.data.data.message){
                    this.props.setReqComplete({head: 'Transaction declined', body: resp.data.data.message});
                }else{
                    this.props.setReqComplete({head: 'Transaction declined', body:'Please make sure that you entered the correct OTP.'});
                }
            }
        })
        .catch((err) => {
            this.props.setReqComplete({head: 'Something went wrong', body:'Please try again later. If this problem persists, please contact your service provider.'});
        });
        event.preventDefault();
    }
    calcPurchase = () => {
        if(this.state.currentPlan){
            let purchase = 0;
            this.state.plans.map((plan) => {
                if(plan.tenorMonth == this.state.currentPlan){
                    purchase = plan.adminFees
                }
            })
            return purchase;
        }else{
            return " - "
        }
    }
    render() {
        return (
                <div className="valuNew">
                    {this.state.waiting ? 
                        <Waiting height={this.state.waitingHeight} />
                    :  
                        <div>
                            {this.state.hideFirstStep?
                                null
                            :
                                <Form onSubmit={this.handleSubmit}>
                                    <div>
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12 ">
                                                <div className="newInput">
                                                    <label>Enter your phone number</label>
                                                        <Input type="number" pattern="[0-9]*"  name="c_pan_U" placeholder="01 xxx xxx xxx"
                                                            value={this.state.phoneNumber} 
                                                            onChange={this.handlePhoneNumberChange}
                                                            validations={[required, PhoneNumber]}
                                                        />
                                                </div>
                                            </div>
                                            {this.state.userData && this.state.userData.allow_downpayment == false ?
                                                null
                                            :
                                                <div className="col-md-6 col-sm-12 ">
                                                    <div className="newInput">
                                                        <label>Down Payment <small>( maximum down payment amount is 80% of the product price -> {max_down_payment}EGP )</small></label>
                                                            <Input type="number"  placeholder="0"
                                                                id="down_payment_input_id"
                                                                value={this.state.downPayment} 
                                                                onChange={this.handleDownPaymentChange}
                                                                validations={[required, MaxDownPayment]}
                                                            />
                                                    </div>
                                                </div>
                                            }
                                            
                                        </div>
                                        <div>
                                            {this.state.userData.allow_gift_card_amount &&
                                                <div className="col-md-6 col-sm-12 ">
                                                    <div className="newInput">
                                                        <label>Gift Card</label>
                                                            <Input type="number" pattern="[0-9]*"  name="c_pan_U" placeholder="-"
                                                                value={this.state.gift_card_amount} 
                                                                onChange={this.handleGiftCardChange}
                                                            />
                                                    </div>
                                                </div>
                                            }
                                            {this.state.userData.allow_cashback &&
                                                <div className="col-md-6 col-sm-12 ">
                                                    <div className="newInput">
                                                        <label>Cashback</label>
                                                            <Input type="number" pattern="[0-9]*"  name="c_pan_U" placeholder="-"
                                                                value={this.state.cashback_amount} 
                                                                onChange={this.handleCashbackChange}
                                                            />
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        {(this.state.phoneNumber.length == 11 &&  Number(this.state.downPayment) >= 0 && Number(this.state.downPayment) <= max_down_payment ) ?
                                            this.state.tenure_waiting ?
                                                <Waiting height='250px' />
                                            :
                                                this.state.check_tenure_error ?
                                                    <div className="err_div_style">{this.state.check_tenure_error_message}</div>
                                                :
                                                    <>
                                                        <div className="InstallmentAmountContainer">
                                                            <div className="InstallmentAmount">
                                                                    <p>Installment:  {total_amount - this.state.downPayment}</p>
                                                            </div>
                                                            {this.props.userData.has_purchase_fees_in_standalone && 
                                                                <div className="InstallmentAmount">
                                                                    <p>Purchase Fees:  {this.calcPurchase()}</p>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="plansDiv">
                                                            <Input type="hidden" className="form-control" placeholder="100"
                                                                value={this.state.currentPlan}
                                                                validations={[required]}
                                                            />
                                                            <RadioGroup name="radio"  onChange = {this.handlePlanChange} required>
                                                                {this.state.plans.map((plan, index) => {
                                                                    return <Radio
                                                                        key= {plan.tenorMonth} 
                                                                        value={plan.tenorMonth}
                                                                        radioClass={this.state.currentPlan == plan.tenorMonth ? "iradio_square-blue checked" : "iradio_square-blue"}
                                                                        increaseArea="20%"                                
                                                                        label={"<span class='paymentMethodSpan'><b>" + plan.tenorMonth + " Months</b><span>" + plan.emi + "/month</span></span>"}
                                                                    />
                                                                })}
                                                            </RadioGroup>
                                                        </div>
                                                        {this.state.firstFormSubmitBtn?
                                                            <div className='text-center'>
                                                                <Button className="confirmBtnNew">Submit</Button>
                                                            </div>
                                                        :
                                                            null
                                                        }
                                                    </>
                                        :
                                            null
                                        }
                                    </div>
                                </Form>
                            }
                            <Form onSubmit={this.handleForm2Submit}>
                                {this.state.secondSetpShow?
                                    <div>
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <div className="newInput">
                                                    <label>Please enter One Time Pin (OTP)</label>
                                                    <Input type="text" name="one time pin" placeholder="PIN"
                                                        value={this.state.pin}
                                                        onChange={this.handelPinChange}
                                                        validations={[required]} 
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='text-center'>
                                            <Button className="confirmBtnNew">Pay</Button>
                                        </div>
                                    </div>
                                :
                                    null
                                }
                            </Form>
                        </div>
                    }
                </div>
        );
    }
}

export default valu;
